import axios from "axios";

//Cycle through all node ids and return a number following the highest one found
export function setNodeId(objs) {
  let maxNum = 0;
  objs.forEach((obj) => {
    let idParts = obj.id.split("_");
    let lastPart = Number(idParts[idParts.length - 1]); //Retrieve the number part of ID (usually the last one)
    if (!isNaN(lastPart) && lastPart > maxNum) {
      maxNum = lastPart;
    }
  });
  return maxNum + 1;
}

//Loop through all nodes and return an array of nodes of the specified type
export function findNodesByType(objs, type) {
  let nodes = objs.filter((nodo) => nodo.type === type);
  return nodes;
}

//Fetchs parameters details for the Operator
export async function fetchDetailsOperator(categoryId, opId, apiDraw, realm) {
  try {
    const response = await axios.get(
      apiDraw +
        "/" +
        realm +
        "/draw/operators?operatorId=" +
        opId +
        "&categoryId=" +
        categoryId,
      { withCredentials: true },
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

//Checks whether the nodeId is contained into 'inputs' list
export function containsNode(targetNode, nodeId) {
  // Check whether 'inputs' is a string array or a node array
  if (targetNode.value.userData.inputs?.length > 0) {
    // If 'inputs' is a string array, search for the string directly
    return targetNode.value.userData.inputs?.includes(nodeId);
  }
}

//Calls API BE Mashup Preview
export async function preview(apiDraw, previewData) {
  const path = apiDraw + window.location.pathname.replace("/edit", "/preview");
  const data = previewData;
  try {
    const response = await axios.post(path, data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

/**
 * Validates the mashup data against the backend service.
 *
 * @param {string} apiDraw - The API endpoint for the draw service.
 * @param {Object} validateData - The data to be validated es.: { draw: ... }.
 * @returns {Promise<Object|null>} - Returns the validation result or null if an error occurs.
 */
export async function validate(apiDraw, validateData) {
  const path = apiDraw + window.location.pathname.replace("/edit", "/validate");
  const data = validateData;
  try {
    const response = await axios.post(path, data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
  return null;
}

/**
 * Validates the connection between nodes based on predefined rules.
 *
 * @param {Object} params - The parameters object containing connection details.
 * @returns {boolean} - Returns true if the connection is valid, otherwise false.
 */
export function validateConnection(params) {
  // Extract numeric IDs from the source and target node identifiers
  const sourceId = params.source.replace(/[^0-9]/g, "");
  const targetId = params.target.replace(/[^0-9]/g, "");

  // Check for invalid connections between 'in_' nodes and 'output' nodes
  if (params.source.startsWith("in_") && params.target === "output") {
    console.warn(
      "Connection between 'in_' node and 'output' node is not allowed.",
    );
    return false;
  }
  // Check for invalid connections between 'output' nodes and 'in_' nodes
  if (params.source === "output" && params.target.startsWith("in_")) {
    console.warn(
      "Connection between 'output' node and 'in_' node is not allowed.",
    );
    return false;
  }
  // Check for self-connections on 'op_' nodes
  if (params.source.startsWith("op_") && sourceId === targetId) {
    console.warn(
      "Connection between handles of the same 'op_' node is not allowed.",
    );
    return false;
  }
  // Check for valid connections from 'in_' nodes to 'op_' nodes via 'left' handles
  if (
    params.source.startsWith("in_") &&
    params.target.startsWith("op_") &&
    params.targetHandle.startsWith("left")
  ) {
    return true;
  }
  // Check for invalid attempts to connect from 'in_' nodes
  if (params.source.startsWith("in_")) {
    console.warn("Invalid connection attempt from 'in_' node:", params);
    return false;
  }
  // Check for valid connections from 'op_' nodes to 'output' nodes via 'right' handles
  if (
    params.source.startsWith("op_") &&
    params.target === "output" &&
    params.sourceHandle.startsWith("right")
  ) {
    return true;
  }
  // Check for invalid attempts to connect to 'output' nodes
  if (params.target === "output") {
    console.warn("Invalid connection attempt to 'output' node:", params);
    return false;
  }
  // Prevent connections between 'op_' nodes from 'left-handle' to 'left-handle'
  if (
    params.source.startsWith("op_") &&
    params.target.startsWith("op_") &&
    params.sourceHandle.startsWith("left") &&
    params.targetHandle.startsWith("left")
  ) {
    console.warn(
      "Connection between 'op_' nodes from 'left-handle' to 'left-handle' is not allowed.",
    );
    return false;
  }
  // Prevent connections between 'op_' nodes from 'right-handle' to 'right-handle'
  if (
    params.source.startsWith("op_") &&
    params.target.startsWith("op_") &&
    params.sourceHandle.startsWith("right") &&
    params.targetHandle.startsWith("right")
  ) {
    console.warn(
      "Connection between 'op_' nodes from 'right-handle' to 'right-handle' is not allowed.",
    );
    return false;
  }
  // Allow connections between 'op_' nodes and any other type of node following the specified rules
  if (
    params.source.startsWith("op_") &&
    (params.target.startsWith("in_") ||
      params.target.startsWith("op_") ||
      params.target === "output")
  ) {
    return true;
  }
  // If none of the above conditions are met, the connection attempt is invalid
  console.warn("Invalid connection attempt:", params);
  return false;
}
